import { render, staticRenderFns } from "./PaymentBreakdownTab.vue?vue&type=template&id=4ef597d2"
import script from "./PaymentBreakdownTab.vue?vue&type=script&lang=js"
export * from "./PaymentBreakdownTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentBreakdownTab.vue?vue&type=style&index=0&id=4ef597d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports